import {useEffect} from "react";
import Lottie from "lottie-react";
import notFound from "../Components/Animations/not-found.json";
import Button from "../Framework/Components/Buttons/Button";
import {ColourMod} from "../Framework/Data/Enums/LayoutEnums";

const NotFound = () => {
    const locationSlug = window.location.pathname.replace('/', '');

    useEffect(() => {
        document.title = `404 Error`;
    }, []);

    return (
        <div className={'inner-content'}>
            <div className={'flex-column align-center justify-center pt-lg pb-lg'} style={{minHeight: '100%'}}>
                <div className={'animation-framer'}>
                    <Lottie animationData={notFound} loop={true} />
                </div>
                <h1 >404: "{locationSlug}" Not Found</h1>

                <Button title={'Home'} actionLink={{ title: 'Go Home', url: '/'}} colour={ColourMod.Primary} />
            </div>
        </div>
    );
};

export default NotFound;